import { render, staticRenderFns } from "./product-transport-form.vue?vue&type=template&id=4e00b954&scoped=true&"
import script from "./product-transport-form.vue?vue&type=script&lang=js&"
export * from "./product-transport-form.vue?vue&type=script&lang=js&"
import style0 from "./product-transport-form.vue?vue&type=style&index=0&id=4e00b954&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e00b954",
  null
  
)

export default component.exports